import { combineReducers } from 'redux'
import { connectRouter } from "connected-react-router";
import authReducer from './app/modules/auth/store/reducer';
import stickerReducer from "./app/modules/stickers/store/reducer";
import layoutReducer from "./app/modules/layout/store/reducer";
import appReducer from './app/modules/app/store/check-browser/reducer';

export default (history) => combineReducers({
  router: connectRouter(history),
  auth: authReducer,
  layout: layoutReducer,
  stickers: stickerReducer,
  app: appReducer,
})
